import uuid from "../../utils/uuid";
import Measure from "./measure";
import Measure3DHelper from "./measure3DHelper";

class PointMeasure3D extends Measure {
  static Type = "point";
  constructor(pointCoordinate, name, viewer) {
    super(name, PointMeasure3D.Type);
    this.potreeMeasure = new window.Potree.ExtendedMeasure(viewer); // todo: use import
    this.potreeMeasure.showDistances = false;
    this.potreeMeasure.showTotalLength = false;
    this.potreeMeasure.showArea = false;
    this.potreeMeasure.closed = false;
    this.potreeMeasure.name = name;
    this.potreeMeasure.measureType = "point";
    this.potreeMeasure.showCoordinates = true;
    this.id = uuid();
    Measure3DHelper.initMarkers(this.potreeMeasure, pointCoordinate);
  }

  getLength() {
    return 0;
  }

  getResult() {
    return 0;
  }

  serialize() {
    return {
      ...super.serialize(),
      ...Measure3DHelper.serialize(this.potreeMeasure),
    };
  }

  static fromPotreeMeasure(potreeMeasure) {
    let measure = new PointMeasure3D([], potreeMeasure.name);
    measure.potreeMeasure = potreeMeasure;
    measure.id = potreeMeasure.dbId;
    measure.toBeStored = potreeMeasure.toBeStored;
    measure.dbId = potreeMeasure.dbId;
    return measure;
  }

  static fromSerialized(serialized) {
    let measure = new PointMeasure3D(serialized.points, serialized.name);
    measure.id = serialized.id;
    measure.toBeStored = serialized.toBeStored;
    measure.potreeMeasure.toBeStored = serialized.toBeStored;
    measure.dbId = serialized.dbId;
    measure.potreeMeasure.dbId = serialized.dbId;
    return measure;
  }
}

export default PointMeasure3D;
